import React from 'react';
import ExploreMarketplaceComponent from '../../components/explore-marketplace-component';


const ExploreMarketplace = () => {
  return (
    <>
      <ExploreMarketplaceComponent />
    </>
  )
}

export default ExploreMarketplace
